import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { CalculoBolsaVacacionesModel } from '../../../core/models/calculoBolsaVacaciones.model';
import { CalculoDiasVacacionesModel } from '../../../core/models/calculoDiasVacaciones.model';
import { BolsaVacacionesService } from '../../../core/services/bolsaVacaciones.service';
import { CalculoDiasVacacionesService } from '../../../core/services/calculoDiasVacaciones.service';


@Component({
  selector: 'app-bolsaHorasVacaciones',
  templateUrl: './bolsaHorasVacaciones.component.html',
  styleUrls: ['./bolsaHorasVacaciones.component.scss'],
  providers: [BolsaVacacionesService, CalculoDiasVacacionesService]
})
export class BolsaHorasVacacionesComponent  implements AfterViewInit {

  panelIcon = 'insert_invitation'; // material icon
  panelTitle = 'Cálculo de vacaciones';
  panelDescription = '';

  bolsaVacaciones: CalculoBolsaVacacionesModel;
  diasVacaciones: CalculoDiasVacacionesModel;

  constructor(
    protected _bolsaVacacionesService: BolsaVacacionesService,
    protected _diasVacacionesService: CalculoDiasVacacionesService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected _location: Location
  ) {
    this.obtenerBolsaVacaciones();
    this.obtenerDiasVacaciones();
  }

  obtenerBolsaVacaciones() {
    // this._bolsaVacacionesService.get().subscribe(res => {
    //   this.bolsaVacaciones = res;
    // },
    // err => {
    //   this._messageDialog.ShowException(err);
    // });
  }

  obtenerDiasVacaciones() {
    // this._bolsaVacacionesService.getDias().subscribe(res => {
    //   this.diasVacaciones = res;
    // },
    // err => {
    //   this._messageDialog.ShowException(err);
    // });
  }

  goBack() {
    this._location.back();
  }


  ngAfterViewInit(): void {

  }
}
